<style lang="scss" scoped>
.page-wrap {
  padding: 8px 0 80px;
  font-family: 'Segoe UI', sans-serif;
}

.panel-card {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 12px rgba(13, 27, 62, 0.07);
  overflow: visible;
}

/* ── Header ── */
.panel-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 20px;
  background: #eef2fb;
  border-bottom: 1px solid #dde4f5;

  .panel-title {
    font-size: 13px;
    font-weight: 700;
    color: #389ad4;
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .record-count {
    font-size: 12px;
    color: #7a8499;
  }
}

/* ── Toolbar ── */
.toolbar {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 14px 20px;
  border-bottom: 1px solid #f0f3fa;
  flex-wrap: wrap;

  .search-box {
    position: relative;
    flex: 1;
    min-width: 180px;
    max-width: 280px;

    i {
      position: absolute;
      left: 11px;
      top: 50%;
      transform: translateY(-50%);
      color: #a0aab8;
      font-size: 13px;
      pointer-events: none;
    }

    input {
      width: 100%;
      height: 36px;
      border: 1.5px solid #dde2ec;
      border-radius: 8px;
      padding: 0 12px 0 32px;
      font-size: 13px;
      color: #0d1b3e;
      outline: none;
      transition: border-color 0.2s;

      &::placeholder { color: #b0bac9; }
      &:focus { border-color: #389ad4; box-shadow: 0 0 0 3px rgba(56,154,212,0.1); }
    }
  }

  .filter-select {
    height: 36px;
    border: 1.5px solid #dde2ec;
    border-radius: 8px;
    padding: 0 28px 0 10px;
    font-size: 13px;
    color: #0d1b3e;
    background: #fff url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='10' height='6'%3E%3Cpath d='M0 0l5 6 5-6z' fill='%23a0aab8'/%3E%3C/svg%3E") no-repeat right 10px center;
    appearance: none;
    outline: none;
    cursor: pointer;
    transition: border-color 0.2s;
    min-width: 190px;

    &:focus { border-color: #389ad4; }
  }

  /* ── Type-and-select ── */
  .ts-wrap {
    position: relative;
    min-width: 190px;
    max-width: 240px;
  }

  .ts-input {
    display: flex;
    align-items: center;
    height: 36px;
    border: 1.5px solid #dde2ec;
    border-radius: 8px;
    padding: 0 10px;
    background: #fff;
    cursor: pointer;
    gap: 6px;
    transition: border-color 0.2s;

    &:hover { border-color: #389ad4; }
    &:focus-within { border-color: #389ad4; box-shadow: 0 0 0 3px rgba(56,154,212,0.1); }
  }

  .ts-val {
    flex: 1;
    font-size: 13px;
    color: #0d1b3e;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    user-select: none;
  }

  .ts-search {
    flex: 1;
    border: none;
    outline: none;
    font-size: 13px;
    color: #0d1b3e;
    font-family: 'Segoe UI', sans-serif;
    background: transparent;
    min-width: 0;

    &::placeholder { color: #b0bac9; }
  }

  .ts-arrow {
    font-size: 10px;
    color: #a0aab8;
    flex-shrink: 0;
    transition: transform 0.2s;
    pointer-events: none;

    &.open { transform: rotate(180deg); }
  }

  .btn-add {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    height: 36px;
    padding: 0 16px;
    background: #F58020;
    color: #fff;
    border: none;
    border-radius: 8px;
    font-size: 13px;
    font-weight: 600;
    cursor: pointer;
    transition: opacity 0.2s;
    white-space: nowrap;
    margin-left: auto;
    text-decoration: none;

    &:hover { opacity: 0.9; }
  }
}

/* ── Type-and-select dropdown (fixed position, escapes overflow) ── */
.ts-dropdown {
  position: fixed;
  background: #fff;
  border: 1.5px solid #dde2ec;
  border-radius: 8px;
  box-shadow: 0 8px 24px rgba(13, 27, 62, 0.12);
  z-index: 9999;
  max-height: 220px;
  overflow-y: auto;
}

.ts-item {
  padding: 8px 12px;
  font-size: 13px;
  color: #0d1b3e;
  font-family: 'Segoe UI', sans-serif;
  cursor: pointer;
  white-space: normal;
  word-break: break-word;
  line-height: 1.4;
  transition: background 0.12s;

  &:hover { background: #f0f7fd; color: #389ad4; }
}

.ts-empty {
  padding: 10px 12px;
  font-size: 12px;
  color: #a0aab8;
  text-align: center;
}

/* ── Table ── */
.svc-table {
  width: 100%;
  font-size: 13px;
  border-collapse: collapse;
  table-layout: auto;

  thead tr th {
    font-size: 11px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.4px;
    color: #7a8499;
    padding: 10px 6px;
    border-bottom: 2px solid #eef0f8;
    background: #fff;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  tbody tr {
    border-bottom: 1px solid #f5f7fa;
    transition: background 0.15s;

    &:last-child { border-bottom: none; }
    &:hover { background: #f8fbff; }

    td {
      padding: 10px 6px;
      color: #2d3748;
      vertical-align: middle;
    }
  }
}

/* ── Service cell (image + name) ── */
.svc-cell {
  display: flex;
  align-items: center;
  gap: 10px;

  .svc-thumb {
    width: 38px;
    height: 38px;
    border-radius: 8px;
    overflow: hidden;
    background: linear-gradient(135deg, #1E6FB8, #389ad4);
    color: #fff;
    font-size: 14px;
    font-weight: 700;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    text-transform: uppercase;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  .svc-info {
    display: flex;
    flex-direction: column;
    gap: 2px;
    min-width: 0;
  }

  .svc-name {
    font-weight: 600;
    color: #0d1b3e;
    white-space: normal;
    word-break: break-word;
    line-height: 1.4;
  }

  .svc-desc {
    color: #7a8499;
    font-size: 11px;
    white-space: normal;
    word-break: break-word;
    line-height: 1.4;
  }
}

.col-muted {
  color: #a0aab8;
  font-size: 12px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* ── Boolean badges ── */
.bool-badge {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 3px 9px;
  border-radius: 20px;
  font-size: 11px;
  font-weight: 700;
  white-space: nowrap;

  &.yes {
    background: #c6f6d5;
    color: #276749;
  }

  &.no {
    background: #f1f5f9;
    color: #94a3b8;
  }
}

/* ── Action 3-dot menu ── */
.action-wrap {
  position: relative;
  display: inline-block;

  .action-btn {
    width: 30px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 6px;
    background: #f5f7fa;
    border: 1px solid #e2e8f0;
    cursor: pointer;
    font-size: 16px;
    font-weight: 700;
    color: #4a5568;
    letter-spacing: 1px;
    transition: background 0.15s;

    &:hover {
      background: #eef2fb;
      color: #185FA5;
      border-color: #c5d4f0;
    }
  }

  .action-menu {
    display: none;
    position: absolute;
    top: calc(100% + 4px);
    right: 0;
    background: #fff;
    border: 1px solid #e2e8f0;
    border-radius: 8px;
    min-width: 140px;
    box-shadow: 0 8px 24px rgba(13, 27, 62, 0.12);
    z-index: 100;
    overflow: hidden;

    &.dropup {
      top: auto;
      bottom: calc(100% + 4px);
    }

    .menu-item {
      display: flex;
      align-items: center;
      gap: 8px;
      padding: 9px 14px;
      font-size: 13px;
      cursor: pointer;
      transition: background 0.15s;

      i { width: 16px; font-size: 13px; }

      &.blue {
        color: #185FA5;
        i { color: #185FA5; }
        &:hover { background: #eef2fb; color: #1E6FB8; i { color: #1E6FB8; } }
      }

      &.danger {
        color: #c62828;
        i { color: #c62828; }
        &:hover { background: #fff5f5; color: #9b1c1c; i { color: #9b1c1c; } }
      }

      &.divider {
        border-top: 1px solid #f0f3fa;
        pointer-events: none;
        padding: 0;
        margin: 0;
      }
    }
  }

  &.open .action-menu { display: block; }
}

/* ── Empty / loading ── */
.state-box {
  text-align: center;
  padding: 56px 24px;
  color: #a0aab8;
  font-size: 13px;

  i {
    font-size: 30px;
    display: block;
    margin-bottom: 10px;
    opacity: 0.45;
  }
}

/* ── Pagination ── */
.pagination-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 20px;
  border-top: 1px solid #f0f3fa;
  flex-wrap: wrap;
  gap: 8px;

  .page-controls {
    display: flex;
    align-items: center;
    gap: 4px;
  }

  .page-btn {
    min-width: 32px;
    height: 32px;
    padding: 0 8px;
    border: 1.5px solid #dde2ec;
    border-radius: 7px;
    background: #fff;
    color: #4a5568;
    font-size: 12px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.15s;

    &:hover:not(:disabled) { border-color: #389ad4; color: #389ad4; }
    &.active { background: #389ad4; color: #fff; border-color: #389ad4; }
    &:disabled { opacity: 0.35; cursor: default; }
  }

  .per-page-wrap {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 12px;
    color: #7a8499;

    select {
      height: 32px;
      border: 1.5px solid #dde2ec;
      border-radius: 7px;
      padding: 0 24px 0 8px;
      font-size: 12px;
      color: #0d1b3e;
      background: #fff url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='8' height='5'%3E%3Cpath d='M0 0l4 5 4-5z' fill='%23a0aab8'/%3E%3C/svg%3E") no-repeat right 7px center;
      appearance: none;
      outline: none;
      cursor: pointer;
    }
  }
}

/* ── Delete modal ── */
.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(13, 27, 62, 0.55);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9000;
  backdrop-filter: blur(3px);
  padding: 20px;
}

.confirm-dialog {
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 24px 64px rgba(13, 27, 62, 0.22);
  width: 100%;
  max-width: 400px;
  overflow: hidden;
  text-align: center;

  .modal-icon-wrap {
    display: flex;
    justify-content: center;
    padding: 28px 24px 0;

    .modal-icon {
      width: 60px;
      height: 60px;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 22px;
      background: #fed7d7;
      color: #c62828;
    }
  }

  .modal-body {
    padding: 20px 28px 24px;

    h3 {
      font-size: 16px;
      font-weight: 700;
      color: #0d1b3e;
      margin: 12px 0 8px;
    }

    p {
      font-size: 13px;
      color: #7a8499;
      margin: 0;
      line-height: 1.6;
    }
  }

  .confirm-footer {
    display: flex;
    gap: 10px;
    padding: 0 28px 24px;

    button {
      flex: 1;
      height: 40px;
      border-radius: 8px;
      font-size: 13px;
      font-weight: 600;
      cursor: pointer;
      transition: all 0.2s;
      border: 1.5px solid;

      &.btn-cancel {
        background: #fff;
        color: #4a5568;
        border-color: #dde2ec;
        &:hover { border-color: #389ad4; color: #389ad4; }
      }

      &.btn-delete {
        background: #c62828;
        color: #fff;
        border-color: #c62828;
        &:hover { background: #9b1c1c; border-color: #9b1c1c; }
      }
    }
  }
}

/* ── QuickBooks sync overlay ── */
.sync-overlay {
  position: fixed;
  inset: 0;
  background: rgba(13, 27, 62, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 8000;
}
</style>

<template>
  <div class="page-wrap">

    <!-- QuickBooks syncing overlay -->
    <div class="sync-overlay" v-if="isQuickBookSyncing">
      <vDataLoader />
    </div>

    <!-- Delete modal -->
    <div class="modal-overlay" v-if="deleteModal" @click.self="deleteModal = false">
      <div class="confirm-dialog">
        <div class="modal-icon-wrap">
          <div class="modal-icon"><i class="fa fa-trash"></i></div>
        </div>
        <div class="modal-body">
          <h3>Delete Service</h3>
          <p>Are you sure you want to delete <strong>{{ deleteTarget && deleteTarget.name }}</strong>?<br />This action cannot be undone.</p>
        </div>
        <div class="confirm-footer">
          <button class="btn-cancel" @click="deleteModal = false">Cancel</button>
          <button class="btn-delete" @click="confirmDelete">Delete</button>
        </div>
      </div>
    </div>

    <div class="panel-card">

      <!-- Header -->
      <div class="panel-header">
        <span class="panel-title">
          <i class="fa fa-concierge-bell"></i>
          Services
          <span style="font-size:12px; color:#7a8499; font-weight:400;" v-if="filteredServices.length">
            ({{ filteredServices.length }})
          </span>
        </span>
        <span class="record-count">
          {{ pagedList.length }} of {{ filteredServices.length }} shown
        </span>
      </div>

      <!-- Toolbar -->
      <div class="toolbar">
        <div class="ts-wrap" v-if="currentUser.u.is_admin" ref="spWrap" v-click-outside="closeSpDropdown">
          <div class="ts-input" @click="toggleSp">
            <span class="ts-val" v-if="!spOpen">{{ spLabel }}</span>
            <input v-if="spOpen" type="text" class="ts-search" v-model="spSearch"
              placeholder="Search provider…" ref="spInput" @keydown.esc="closeSpDropdown" />
            <i class="fa fa-chevron-down ts-arrow" :class="{ open: spOpen }"></i>
          </div>
          <div class="ts-dropdown" v-if="spOpen" :style="spDropStyle">
            <div class="ts-item" @click="selectSp('all')">All Service Providers</div>
            <div class="ts-item" v-for="(p, i) in filteredSp" :key="i" @click="selectSp(p.id)">{{ p.name }}</div>
            <div class="ts-empty" v-if="filteredSp.length === 0 && spSearch">No match</div>
          </div>
        </div>

        <div class="search-box">
          <i class="fa fa-search"></i>
          <input
            v-model="searchInput"
            type="text"
            placeholder="Search services…"
          />
        </div>

        <router-link
          v-if="currentUser.u.roles == 'admin'"
          :to="{ name: 'client.service.create' }"
          style="margin-left:auto; text-decoration:none;"
        >
          <button class="btn-add">
            <i class="fa fa-plus"></i> Add Service
          </button>
        </router-link>
      </div>

      <!-- Loading -->
      <div class="state-box" v-if="loadingData">
        <i class="fa fa-spinner fa-spin"></i>
        Loading services…
      </div>

      <!-- Empty -->
      <div class="state-box" v-else-if="filteredServices.length === 0">
        <i class="fa fa-cube"></i>
        No services found
      </div>

      <!-- Table -->
      <div v-else>
        <table class="svc-table">
          <thead>
            <tr>
              <th style="width:32px;">#</th>
              <th style="width:220px;">Service</th>
              <th style="width:70px;">Type</th>
              <th style="width:72px;">Status</th>
              <th style="width:88px;">QuickBooks</th>
              <th style="width:78px;">QB Account</th>
              <th style="width:64px;">Drug Test</th>
              <th style="width:64px;">Featured</th>
              <th v-if="currentUser.u.roles == 'admin'" style="width:48px; text-align:center;">Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in pagedList" :key="item.id || index">
              <td style="color:#a0aab8; font-size:12px;">{{ (currentPage - 1) * perPage + index + 1 }}</td>

              <td>
                <div class="svc-cell">
                  <div class="svc-thumb">
                    <img
                      v-if="item.image"
                      :src="getBServices.url + item.image"
                      :alt="item.name"
                      @error="e => e.target.style.display='none'"
                    />
                    <span v-else>{{ (item.name || '?').charAt(0) }}</span>
                  </div>
                  <div class="svc-info">
                    <span class="svc-name">{{ item.name }}</span>
                    <span class="svc-desc" v-if="item.description">{{ globalSubStr(item.description, 60) }}</span>
                  </div>
                </div>
              </td>

              <td style="color:#4a5568; font-size:12px;">{{ item.service_type || '—' }}</td>

              <td>
                <span class="bool-badge" :class="item.is_active ? 'yes' : 'no'">
                  {{ item.is_active ? 'Active' : 'Inactive' }}
                </span>
              </td>

              <td>
                <template v-if="currentUser.u.is_admin">
                  <span class="bool-badge" :class="item.is_admin_quickbooks_synced ? 'yes' : 'no'">
                    {{ item.is_admin_quickbooks_synced ? 'Synced' : 'Not Synced' }}
                  </span>
                </template>
                <template v-else>
                  <span class="bool-badge" :class="item.is_quickbooks_synced ? 'yes' : 'no'">
                    {{ item.is_quickbooks_synced ? 'Synced' : 'Not Synced' }}
                  </span>
                </template>
              </td>

              <td class="col-muted">{{ item.QB_account_id || '—' }}</td>

              <td>
                <span class="bool-badge" :class="item.is_drug_testing ? 'yes' : 'no'">
                  {{ item.is_drug_testing ? 'Yes' : 'No' }}
                </span>
              </td>

              <td>
                <span class="bool-badge" :class="item.is_featured ? 'yes' : 'no'">
                  {{ item.is_featured ? 'Yes' : 'No' }}
                </span>
              </td>

              <td
                v-if="currentUser.u.roles == 'admin'"
                style="text-align:center; overflow:visible;"
                @click.stop
              >
                <div
                  class="action-wrap"
                  :class="{ open: openIndex === index }"
                  @click.stop="toggleDropdown(index, $event)"
                >
                  <div class="action-btn">•••</div>
                  <div class="action-menu" :class="{ dropup: dropupIndex === index }">
                    <div class="menu-item blue" @click.stop="editData(item.id)">
                      <i class="fa fa-pencil-alt"></i> Edit
                    </div>
                    <div class="menu-item divider"></div>
                    <div class="menu-item danger" @click.stop="openDeleteModal(item, (currentPage - 1) * perPage + index)">
                      <i class="fa fa-trash"></i> Delete
                    </div>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Pagination -->
      <div class="pagination-bar" v-if="!loadingData && totalPages > 1">
        <div class="page-controls">
          <button class="page-btn" @click="currentPage = 1" :disabled="currentPage === 1">«</button>
          <button class="page-btn" @click="currentPage--" :disabled="currentPage === 1">‹</button>
          <button
            v-for="p in visiblePages"
            :key="p"
            class="page-btn"
            :class="{ active: p === currentPage }"
            @click="currentPage = p"
          >{{ p }}</button>
          <button class="page-btn" @click="currentPage++" :disabled="currentPage === totalPages">›</button>
          <button class="page-btn" @click="currentPage = totalPages" :disabled="currentPage === totalPages">»</button>
        </div>
        <div class="per-page-wrap">
          Rows per page
          <select v-model="perPage" @change="currentPage = 1">
            <option :value="10">10</option>
            <option :value="25">25</option>
            <option :value="50">50</option>
          </select>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/mutations.type";
import {
  FETCH_B_SERVICES,
  DELETE_B_SERVICE,
  SYNC_QUICKBOOK_SERVICES,
  GET_SERVICE_PROVIDER_LIST,
} from "@/core/services/store/actions.type";
import vDataLoader from "@/components/frontend/spinner.vue";
import { mapGetters } from "vuex";

export default {
  components: { vDataLoader },
  directives: {
    clickOutside: {
      bind(el, binding) {
        el._clickOutsideHandler = e => { if (!el.contains(e.target)) binding.value(e); };
        document.addEventListener("mousedown", el._clickOutsideHandler);
      },
      unbind(el) {
        document.removeEventListener("mousedown", el._clickOutsideHandler);
      }
    }
  },
  computed: {
    ...mapGetters(["getBServices", "currentUser", "getserviceProviders"]),
    filteredSp() {
      const q = (this.spSearch || "").toLowerCase();
      const list = this.getserviceProviders || [];
      return q ? list.filter(p => p.name && p.name.toLowerCase().includes(q)) : list;
    },
    spLabel() {
      if (this.service_provider === "all") return "All Service Providers";
      const p = (this.getserviceProviders || []).find(p => p.id === this.service_provider);
      return p ? p.name : "All Service Providers";
    },
    filteredServices() {
      let list = this.getBServices.data || [];
      if (this.searchInput) {
        list = list.filter(item =>
          item.name.toUpperCase().includes(this.searchInput.toUpperCase())
        );
      }
      return list;
    },
    totalPages() {
      return Math.ceil(this.filteredServices.length / this.perPage) || 1;
    },
    pagedList() {
      const start = (this.currentPage - 1) * this.perPage;
      return this.filteredServices.slice(start, start + this.perPage);
    },
    visiblePages() {
      const pages = [];
      for (let p = Math.max(1, this.currentPage - 2); p <= Math.min(this.totalPages, this.currentPage + 2); p++) {
        pages.push(p);
      }
      return pages;
    }
  },
  watch: {
    filteredServices() {
      this.currentPage = 1;
    }
  },
  data() {
    return {
      breadCrumbs: [
        { id: 1, title: "Dashboard", route: "client.dashboard" },
        { id: 2, title: "Services", route: "" }
      ],
      service_provider: "all",
      spOpen: false, spSearch: "", spDropStyle: {},
      loadingData: false,
      searchInput: "",
      isQuickBookSyncing: false,
      currentPage: 1,
      perPage: 10,
      openIndex: null,
      dropupIndex: null,
      deleteModal: false,
      deleteTarget: null,
      deleteIndex: null
    };
  },
  created() {
    this.$store.commit(SET_BREADCRUMB, this.breadCrumbs);
    if (this.currentUser.u.is_admin) {
      this.getServiceProvider();
    } else {
      this.getServiceData();
    }
    document.addEventListener("click", this.closeDropdown);
  },
  beforeUnmount() {
    document.removeEventListener("click", this.closeDropdown);
  },
  methods: {
    toggleSp() {
      this.spOpen = !this.spOpen;
      if (this.spOpen) {
        this.spSearch = "";
        this.$nextTick(() => {
          if (this.$refs.spInput) this.$refs.spInput.focus();
          const wrap = this.$refs.spWrap;
          if (wrap) {
            const r = wrap.getBoundingClientRect();
            this.spDropStyle = { position: "fixed", top: (r.bottom + 4) + "px", left: r.left + "px", width: r.width + "px", zIndex: 9999 };
          }
        });
      }
    },
    closeSpDropdown() { this.spOpen = false; this.spSearch = ""; this.spDropStyle = {}; },
    selectSp(id) {
      this.service_provider = id;
      this.closeSpDropdown();
      this.getServiceData();
    },
    openDeleteModal(item, index) {
      this.deleteTarget = item;
      this.deleteIndex = index;
      this.deleteModal = true;
      this.openIndex = null;
    },
    confirmDelete() {
      this.$store
        .dispatch(DELETE_B_SERVICE, this.deleteTarget.id)
        .then(data => {
          this.getBServices.data.splice(this.deleteIndex, 1);
          this.$toastr.s(data.msg);
        })
        .catch(err => { this.$toastr.e(err.error); });
      this.deleteModal = false;
    },
    syncQuickBooks(id) {
      this.isQuickBookSyncing = true;
      this.$store.dispatch(SYNC_QUICKBOOK_SERVICES, id)
        .then(() => {
          this.isQuickBookSyncing = false;
          this.$toastr.s("Synced Successfully");
          this.getServiceData();
        })
        .catch(e => {
          this.isQuickBookSyncing = false;
          this.$toastr.e(e.msg);
        });
    },
    editData(id) {
      this.$router.push({ name: "client.service.edit", params: { id } });
    },
    getServiceData() {
      this.loadingData = true;
      this.$store
        .dispatch(FETCH_B_SERVICES, { status: "all", service_provider: this.service_provider })
        .then(() => { this.loadingData = false; })
        .catch(() => { this.loadingData = false; });
    },
    getServiceProvider() {
      this.$store
        .dispatch(GET_SERVICE_PROVIDER_LIST)
        .then(res => {
          if (res.code == 200 && this.getserviceProviders.length > 0) {
            this.service_provider = this.getserviceProviders[0].id;
            this.getServiceData();
          }
        })
        .catch(err => { this.msg = err.error; });
    },
    toggleDropdown(index, event) {
      this.openIndex = this.openIndex === index ? null : index;
      if (this.openIndex === index) {
        this.$nextTick(() => {
          const el = event.currentTarget;
          const menu = el.querySelector(".action-menu");
          if (menu) {
            const rect = el.getBoundingClientRect();
            this.dropupIndex = (window.innerHeight - rect.bottom) < (menu.scrollHeight || 120) + 30 ? index : null;
          }
        });
      } else {
        this.dropupIndex = null;
      }
    },
    closeDropdown() {
      this.openIndex = null;
      this.dropupIndex = null;
    }
  }
};
</script>
